import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Select } from 'antd';

import type { ITeamPocFields } from '@/interface/teamPocFields.interface';

const TeamPocFields = ({
  team,
  pocNames,
  teamOptions,
  pocOptions,
  teamError,
  pocError,
  teamLabel,
  teamPlaceholder,
  teamRequiredMessage,
  pocLabel,
  pocPlaceholderPrefix,
  pocRequiredMessage,
  removePocAriaLabelPrefix,
  teamSelectClassName = 'w-full',
  pocInputClassName = '',
  teamLabelClassName = 'block text-sm font-medium text-gray-700',
  pocLabelClassName = 'block text-sm font-medium text-gray-700',
  singlePocOnly = false,
  onTeamChange,
  onPocNameChange,
  onAddPocName,
  onRemovePocName,
}: ITeamPocFields) => {
  return (
    <>
      <div>
        <label className={teamLabelClassName}>{teamLabel}</label>
        <Select
          placeholder={teamPlaceholder}
          value={team}
          onChange={onTeamChange}
          options={teamOptions}
          className={teamSelectClassName}
        />
        {teamError && <div className="text-red-500 text-xs mt-1">{teamRequiredMessage}</div>}
      </div>

      <div>
        <label className={pocLabelClassName}>{pocLabel}</label>
        <div className="mt-1 space-y-2">
          {pocNames.map((name, index) => (
            <div key={`team-poc-${index}`} className="flex items-center gap-2">
              {pocOptions ? (
                <Select
                  showSearch
                  placeholder={`${pocPlaceholderPrefix} ${index + 1}`}
                  value={name || undefined}
                  onChange={(value) => onPocNameChange(index, value)}
                  options={pocOptions}
                  className={`w-full ${pocInputClassName}`}
                  optionFilterProp="label"
                />
              ) : (
                <Input
                  placeholder={`${pocPlaceholderPrefix} ${index + 1}`}
                  value={name}
                  onChange={(event) => onPocNameChange(index, event.target.value)}
                  className={pocInputClassName}
                />
              )}
              {!singlePocOnly && (
                <Button
                  type="text"
                  danger
                  aria-label={`${removePocAriaLabelPrefix} ${index + 1}`}
                  icon={<MinusCircleOutlined />}
                  disabled={pocNames.length === 1}
                  onClick={() => onRemovePocName(index)}
                />
              )}
            </div>
          ))}
          {!singlePocOnly && (
            <Button type="dashed" icon={<PlusOutlined />} onClick={onAddPocName}>
              Add POC
            </Button>
          )}
        </div>
        {pocError && <div className="text-red-500 text-xs mt-1">{pocRequiredMessage}</div>}
      </div>
    </>
  );
};

export default TeamPocFields;
